import { Model } from "@interfaces/model.interface";

export interface ToolroomProcess extends Model {
	defaultOpNumber?: number;
	isActive: boolean;
	isDefault: boolean;
	name: string;
}

export class ToolroomProcess implements ToolroomProcess {
	isActive = true;
	isDefault = false;
	name = "";

	constructor(data?: Partial<ToolroomProcess>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
